import React, {useEffect, useMemo, useState} from 'react';
import { Progress } from 'antd';
import {Colors} from "../../styles/Colors";

const FILE_UPLOAD_PROGRESS_CAP = 90;

const FakeProgress = (props) => {
    const {status, timeLimit} = props
    const timeMax = useMemo(() => timeLimit ? timeLimit : FILE_UPLOAD_PROGRESS_CAP, [timeLimit]);
    const [percent, setPercent] = useState(0);

    useEffect(() => {
        if (status !== 'uploading') return;
        setPercent((prev) => (prev === 0 ? 8 : prev));
        const intervalId = setInterval(() => {
            setPercent((prev) => {
                if (prev >= timeMax) return prev;
                const remaining = timeMax - prev;
                const step = Math.max(1, remaining * 0.08); // ease-out toward the cap
                return Math.min(timeMax, prev + step);
            });
        }, 250);
        return () => clearInterval(intervalId);
    }, [status]);

    useEffect(() => {
        if (status === 'done') setPercent(100);
        if (status === 'error') setPercent(0);
    }, [status]);

    return (
        <Progress
            percent={Math.round(percent)}
            status={status === 'done' ? 'success' : 'active'}
            showInfo={false}
            size={['100%', 2]}
            strokeColor={Colors.active}
            style={{marginTop: '0.3rem'}}
        />
    );
};

export default FakeProgress;